import { render, staticRenderFns } from "./OptionRadio.vue?vue&type=template&id=5613438b&scoped=true&"
import script from "./OptionRadio.vue?vue&type=script&lang=js&"
export * from "./OptionRadio.vue?vue&type=script&lang=js&"
import style0 from "./OptionRadio.vue?vue&type=style&index=0&id=5613438b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5613438b",
  null
  
)

export default component.exports